import { Routes } from '@angular/router';
import { BriefApplicationCleanup } from './molecules/brief-application-cleanup/brief-application-cleanup';
import { BriefTracker } from './molecules/brief-tracker/brief-tracker';
import { BusinessStats } from './molecules/business-stats/business-stats';
import { BusinessStatsDashboard } from './molecules/business-stats/business-stats-dashboard/business-stats-dashboard';
import { BusinessStatsList } from './molecules/business-stats/business-stats-list/business-stats-list';
import { CreatorManualRegistration } from './molecules/creator-manual-registration/creator-manual-registration';
import { CreatorPaymentDetailsFix } from './molecules/creator-payment-details-fix/creator-payment-details-fix';
import { CreatorStats } from './molecules/creator-stats/creator-stats';
import { CreatorStatsDashboard } from './molecules/creator-stats/creator-stats-dashboard/creator-stats-dashboard';
import { CreatorStatsList } from './molecules/creator-stats/creator-stats-list/creator-stats-list';
import { AdminBrandVouchers } from './molecules/brand-vouchers/brand-vouchers';
import { AdminBrandVouchersCreate } from './molecules/brand-vouchers/molecules/brand-vouchers-create/brand-vouchers-create';
import { AdminBrandVouchersList } from './molecules/brand-vouchers/molecules/brand-vouchers-list/brand-vouchers-list';
import { AdminBrandVoucherProfile } from './molecules/brand-vouchers/molecules/brand-voucher-profile/brand-voucher-profile';
import { PayoutRetryFix } from './molecules/payout-retry-fix/payout-retry-fix';
import { Reports } from './molecules/reports/reports';
import { ReportsDashboard } from './molecules/reports/molecules/reports-dashboard/reports-dashboard';
import { ReportsList } from './molecules/reports/molecules/reports-list/reports-list';
import { SandboxUserConfig } from './molecules/sandbox-user-config/sandbox-user-config';
import { SuperSocials } from './molecules/super-socials/super-socials';
import { ADMIN_TOOL_ROUTE_SEGMENTS } from './molecules/admin-tool-registry/admin-tool.registry';

export const adminSettingsRoutes: Routes = [
  { path: '', redirectTo: ADMIN_TOOL_ROUTE_SEGMENTS['payout-retry-fix'], pathMatch: 'full' },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['payout-retry-fix'], component: PayoutRetryFix },
  {
    path: ADMIN_TOOL_ROUTE_SEGMENTS['brand-vouchers'],
    component: AdminBrandVouchers,
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      { path: 'new', component: AdminBrandVouchersCreate },
      { path: 'list', component: AdminBrandVouchersList },
      { path: 'list/:id', component: AdminBrandVoucherProfile },
    ],
  },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['creator-payment-details-fix'], component: CreatorPaymentDetailsFix },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['brief-application-cleanup'], component: BriefApplicationCleanup },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['brief-tracker'], component: BriefTracker },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['super-socials'], component: SuperSocials },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['creator-manual-registration'], component: CreatorManualRegistration },
  {
    path: ADMIN_TOOL_ROUTE_SEGMENTS['creator-stats'],
    component: CreatorStats,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'list', component: CreatorStatsList },
      { path: 'dashboard', component: CreatorStatsDashboard },
    ],
  },
  {
    path: ADMIN_TOOL_ROUTE_SEGMENTS['business-stats'],
    component: BusinessStats,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'list', component: BusinessStatsList },
      { path: 'dashboard', component: BusinessStatsDashboard },
    ],
  },
  {
    path: ADMIN_TOOL_ROUTE_SEGMENTS.reports,
    component: Reports,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: ReportsDashboard },
      { path: 'list', component: ReportsList },
    ],
  },
  { path: ADMIN_TOOL_ROUTE_SEGMENTS['sandbox-user-config'], component: SandboxUserConfig },
];
